<template>
  <div class="toolbar-wrapper">
    <div class="container">
      <div class="row" v-if="designLoaded">
        <div class="col locked-toolbar" v-if="lockButtons">
          <ul>
            <li>
              <b-button-group>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip  title="Undo (⌘+z)" variant="clear" :disabled="!canvasState.canUndo" @click="emit('undo')">
                  <i class="fa fa-undo" aria-hidden="true"></i> <span class="label">Undo</span>
                </b-button>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip title="Redo (⌘+shift+z)" variant="clear" :disabled="!canvasState.canRedo" @click="emit('redo')">
                  <i class="fa fa-redo" aria-hidden="true"></i> <span class="label">Redo</span>
                </b-button>
              </b-button-group>
            </li>
            <li>
              <b-button-group>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip  title="Previous field" variant="clear" @click="emit('prevObject')">
                  <i class="fas fa-arrow-left" aria-hidden="true"></i> <span class="label">Prev Field</span>
                </b-button>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip title="Next field" variant="clear" @click="emit('nextObject')">
                  <i class="fas fa-arrow-right" aria-hidden="true"></i> <span class="label">Next Field</span>
                </b-button>
              </b-button-group>
            </li>
            <li v-if="canvasState.fieldDeletable">
                <b-button variant="clear" v-b-tooltip.hover v-disable-mobile-tooltip title="Delete Object" @click="emit('deleteField')">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </b-button>
            </li>
          </ul>
        </div>
        <div class="col unlocked-toolbar" v-else>
          <ul>
            <li>
              <b-button-group>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip  title="Undo (⌘+z)" variant="clear" :disabled="!canvasState.canUndo" @click="emit('undo')">
                  <i class="fa fa-undo" aria-hidden="true"></i>
                </b-button>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip title="Redo (⌘+shift+z)" variant="clear" :disabled="!canvasState.canRedo" @click="emit('redo')">
                  <i class="fa fa-redo" aria-hidden="true"></i>
                </b-button>
              </b-button-group>
            </li>
            <li>
              <b-button-group>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip title="Duplicate" variant="clear" @click="emit('duplicateFieldOrAddText')">
                  <i class="fa fa-clone" aria-hidden="true"></i>
                </b-button>
                <b-button variant="clear" v-b-tooltip.hover v-disable-mobile-tooltip title="Delete Object" @click="emit('deleteField')">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </b-button>
              </b-button-group>
            </li>
            <li>
              <EditModeToggle @onTextMode="emit('onTextMode')" @onMoveMode="emit('onMoveMode')"></EditModeToggle>
            </li>
            <li v-if="flags.toggleCropBleed">
              <b-button
                placement="bottom"
                v-b-tooltip.hover v-disable-mobile-tooltip
                title="Toggle Display Bleed"
                variant="clear"
                @click="emit('toggleDisplayBleed')"
              >
                <i class="fa fa-crop" aria-hidden="true"></i>
              </b-button>
            </li>
            <li>
              <ul class="list-group">
                <li class="item fonts">
                  <b-dropdown variant="clear" :text="canvasState.fontName" class="m-md-2" id="font-dropdown" :style="{fontFamily:canvasState.fontName}" v-b-tooltip.hover v-disable-mobile-tooltip title="Click on active text to view font family">
                    <b-dropdown-item v-for="font in canvasState.fonts" :key='font' @click="onChangeFontName(font)" :style="{fontFamily:font}">{{font}}</b-dropdown-item>
                  </b-dropdown>
                </li>
                <li v-if="flags.debugTools && dlFontUrl" class="item debug-item">
                  <a :href="dlFontUrl"><i class="fas fa-download"/></a>
                </li>
                <li class="item">
                  <div class="font-size-wrapper dropdown-menu-right">
                    <input type="text" size="6" :value="canvasState.fontSize" @change="onChangeFontSize" name="currentFontSize" v-b-tooltip.hover v-disable-mobile-tooltip title="Click on active text to view font size">
                  </div>
                  <div class="dropdown-menu dropdown-menu-right dropdown-menu-font-sizes" aria-labelledby="fontSize">
                    <button >
                    </button>
                  </div>
                </li>
                <li class="item">
                  <b-dropdown variant="clear" size="lg">
                    <template slot="button-content">
                      <i class="current color-square" aria-hidden="true" :style="`background-color: ${canvasState.color};`"></i>
                    </template>
                    <b-dropdown-header>Document Colors</b-dropdown-header>
                    <b-dropdown-item v-for="color of canvasState.colors" :key="color" @click="onChangeColor(color)">
                      <button class="dropdown-item color-square" :style="`background-color: ${color};`"></button> <!--ANGULAR: *ngFor="let color of row" [style.background]="'rgb('+color.rgb+')'" (click)="onColor.emit(color.rgb)"-->
                    </b-dropdown-item>
                  </b-dropdown>
                </li>

                <li class="item debug-item" style="white-space: nowrap" v-if="flags.debugTools">
                  pos: <input type="text" size="6" :value="posX" @change="onChangePositionX" name="positionX">
                  <input type="text" size="6" :value="posY" @change="onChangePositionY" name="positionY">
                </li>

                <li v-if="isTemplate">
                  <b-form-radio-group
                    buttons
                    button-variant="clear"
                    :checked="canvasState.originX"
                    :disabled="!canvasState.originX"
                    @input="onChangeAlignment"
                  >
                    <b-form-radio value="left"><i class="fas fa-align-left"></i></b-form-radio>
                    <b-form-radio value="center"><i class="fas fa-align-center"></i></b-form-radio>
                    <b-form-radio value="right"><i class="fas fa-align-right"></i></b-form-radio>
                  </b-form-radio-group>
                </li>

                <li>
                  <b-button
                    v-if="flags.enableSuperscript"
                    placement="bottom"
                    v-b-tooltip.hover v-disable-mobile-tooltip
                    title="Superscript"
                    variant="clear"
                    @click="emit('setSuperscript')"
                  ><i class="fa fa-superscript" aria-hidden="true"></i>
                  </b-button>
                </li>
              </ul>
            </li>

            <li>
              <b-button-group>
                <b-button placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip title="Upload Image" variant="clear" @click="emit('showUploadDialog')">
                  <i class="fa fa-upload" aria-hidden="true"></i>
                </b-button>
                <b-button v-if="isTemplate" placement="bottom" v-b-tooltip.hover v-disable-mobile-tooltip title="Make Image Placeholder" variant="clear" @click="emit('makePlaceholder')">
                  <i class="fa fa-image" aria-hidden="true"></i>
                </b-button>
              </b-button-group>
            </li>

            <li>
              <b-button-group>
                <b-button
                  v-if="isTemplate && flags.enableFieldOptions"
                  placement="bottom"
                  v-b-tooltip.hover v-disable-mobile-tooltip
                  title="Field options"
                  variant="clear"
                  @click="emit('toggleFieldOptions')"
                  :class="{active: showingFieldOptions}">
                  <i class="fa fa-code" aria-hidden="true"></i>
                </b-button>
              </b-button-group>
            </li>

            <li>
              <b-button-group>
                <b-button
                  v-if="isTemplate && flags.enableLockTemplate"
                  placement="bottom"
                  v-b-tooltip.hover v-disable-mobile-tooltip
                  title="Lock design"
                  variant="clear"
                  @click="toggleLockDesign"
                  :class="{active: designLocked}">
                  <i class="fa fa-lock" aria-hidden="true"></i>
                </b-button>
              </b-button-group>
            </li>

          </ul>

        </div>
        <DebugTools style="float: right"/>
      </div>
    </div>
  </div>
</template>



<script>
import DebugTools from './DebugTools.vue';
import EditModeToggle from './EditModeToggle'
import {mapGetters, mapActions} from 'vuex';
import isMobile from '@/lib/isMobile';
import dlFontUrl from '@/lib/admin/dlFontUrl';

export default {
  props: ['bus', 'canvasState', 'designLocked'],
  components: {DebugTools, EditModeToggle},
  mounted() {
    window.addEventListener('keydown', this.keypress);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keypress);
  },
  computed: {
    ...mapGetters(['flags', 'isTemplate', 'validUploadTypes', 'design', 'designOptions']),
    designLoaded() {
      return !!this.design;
    },
    lockButtons() {
      return this.designLocked && !this.isTemplate;
    },
    posX() {
      if (!this.canvasState.position) return '';
      return Math.round(this.canvasState.position.x*100)/100;
    },
    posY() {
      if (!this.canvasState.position) return '';
      return Math.round(this.canvasState.position.y*100)/100;
    },
    dlFontUrl() {
      return dlFontUrl(this.canvasState.fontName);
    }
  },

  methods: {
    ...mapActions(['setDesignOptions']),
    keypress(evt) {

      // avoid catching keypresses if user is typing in another field in the editor
      if (document.activeElement &&
        (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA')){
        return;
      }

      let emittedEvent = false;

      if (!this.lockButtons && (evt.keyCode === 8 || evt.keyCode == 46)){
        this.emit('deleteField');
        emittedEvent = true;
      }

      //ctrl/cmd z or ctrl/cmd + Shift z
      if (evt.keyCode === 90 && (evt.metaKey || evt.ctrlKey)) {
        this.emit(evt.shiftKey ? 'redo' : 'undo');
        emittedEvent = true;
      }

      if (emittedEvent){
        evt.stopPropagation();
      }
    },
    emit(event, value) {
      this.bus.$emit(event, value);
    },
    onChangeFontSize(event) {
      this.emit('fontSize', parseFloat(event.target.value));
    },
    onChangeFontName(newName) {
      this.emit('fontName', newName);
    },
    onChangeColor(newColor) {
      this.emit('color', newColor);
    },
    onChangeAlignment(newAlignment) {
      if (newAlignment !== this.canvasState.originX) {
        this.emit('setOriginX', newAlignment);
      }
    },

    onChangePositionX(event) {
      this.onChangePosition(event, 'x');
    },

    onChangePositionY(event) {
      this.onChangePosition(event, 'y');
    },

    onChangePosition(event, attr) {
      let value = parseFloat(event.target.value);
      let pos = this.canvasState.position;
      let cur = pos[attr];
      if (!pos || isNaN(value) || cur === value) return;
      this.emit('setPosition', {...pos, [attr]: value});
    },

    toggleLockDesign() {
      let {lockDesign, ...rest} = this.designOptions;
      lockDesign = !lockDesign;
      this.setDesignOptions({lockDesign, ...rest});
    }
  },
  data() {
    return {showingFieldOptions: false}
  },

  directives:{
    // tooltip seems to block click on mobile so this disables it.
    //
    // This demo I made on codepen seems to work, however. https://codepen.io/TheRoccoB/pen/MLrEGb
    // not sure if some dependency (v-bootstrap?) needs to be updated or what, but this solves the problem for now.
    "disable-mobile-tooltip":{
      inserted(el){
        //set timeout to make sure that the v-b-tooltip directive has already been done
        setTimeout(() => {
          const BVTT = '__BV_ToolTip__';
          if (isMobile() && el[BVTT]){
            if (el[BVTT]) {
              el[BVTT].destroy();
              el[BVTT] = null;
              delete el[BVTT];
            }
          }
        }, 1);
      }
    }
  },
  events: {
    fieldOptionsVisibilityChange({shown}) {
      this.showingFieldOptions = shown;
    }
  }
}
</script>
<style lang="scss">
// Fix weird issue where drop down menu of fonts is displayed horizontally
ul.dropdown-menu > li[role="presentation"] {
  display: block;
}
</style>
<style scoped lang="scss">
  @import '~scss/abstracts/_variables';
  @import '~bootstrap/scss/_functions';
  @import '~bootstrap/scss/_variables';
  @import '~bootstrap/scss/mixins/_breakpoints';
  @import '~scss/colors';

  .spacer{
   height: 60px;
   background-color:  $gray-3;  }

  :host {
    position: relative;
  }

  .toolbar-wrapper {
    height: 50px;
    width: 100%;
    background-color: $gray-3;
    position:fixed;
    top: $navbar-height;
    z-index: 5;
    color: get-theme-color('primary', 'dark');
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);

    @include media-breakpoint-up(sm) {
      left: 0;
      //left: 90px;
    }

    @include media-breakpoint-only(xs) {
      left: 0;
      //left: 80px;
    }

    .x-scroll {
      max-width: 100%;
      height: 100%;
      overflow-x: auto;
      // TODO chrome bug forces overflow-y to auto when overflow-x is set
      // This breaks dropdown menus
      overflow-y: visible !important;

      // Hide scrollbar when possible
      -ms-overflow-style: none;
      scrollbar-width: none; // Firefox
      &::-webkit-scrollbar { // Chrome etc
        display: none;
      }
    }

    // TODO this is the source weird issue where drop down menu of fonts is displayed horizontally
    // This should not apply to the '<li>' from within the <b-dropdown-item>, but it seems to be doing
    // that
    ul {
      list-style-type: none;
      display: inline-table;
    }

    li {
      display: table-cell;
      line-height: 50px;
      padding: 0 15px;

      .label {
        // Extra small devices (portrait phones, less than 576px)
        @media (max-width: 575.98px) {
          display: none;
        }
      }

      &.item {
        cursor: pointer;

        .color-picker {
          i {
            display: inline-block;
            font-size: 1.33333333em;
            line-height: 0.75em;
            border-radius: 5px;
            width: 25px;
            height: 25px;
            vertical-align: middle;
            box-shadow: inset 1px 1px 6px rgba(0, 0, 0, .15), inset -1px -1px 0 rgba(255, 255, 255, .25);
            border: none !important;
          }
        }

        &.debug-item {
          border: 1px dashed blue;
        }

      }

      &.active {
        background: get-theme-color('primary', 'dark');
        color: $gray-3;
      }
    }

    //prevents double spacing to the left and right of fonts selector
    .list-group {
      margin-left:-15px;
      margin-right:-15px;
    }

    .dropdown-menu {
      max-height: 300px;
      overflow-y: scroll;
    }

    .dropdown-menu-font-sizes {
      min-width: 80px;

      button {
        line-height: normal;
        height: 30px;
      }
    }

    .color-row {
      margin: 0;
      padding: 0;
      height: 40px;

      &:first-child {
        .color-square:first-child {
          border-top-left-radius: 4px;
        }

        .color-square:last-child {
          border-top-right-radius: 5px;
        }
      }

      &:last-child {
        .color-square:first-child {
          border-bottom-left-radius: 4px;
        }

        .color-square:last-child {
          border-bottom-right-radius: 5px;
        }
      }

    }

    .color-square {
      width: 40px;
      height: 40px;
      box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .05), inset -1px -1px 0 rgba(0, 0, 0, .05);
      border: none !important;
      display: inline-block;

      &.current {
        width: 16px;
        height: 16px;
        // For some reason the content is 20px high. This fixes it
        margin-bottom: -4px;
      }

      &:hover {
        opacity: 0.5;
        filter: alpha(opacity=50);
      }
    }

    .font-size-wrapper {
      input {
        padding: 7px;
        font-size: 14px;
        width: 3.5em;
      }
      &:after {
        position: relative;
        margin: 0;
        left: -17px;
      }
    }

    a[disabled] {
      color: #aaa;
    }

  }

</style>
<style lang="scss">
  @import '~scss/colors';

.toolbar-wrapper {
  .btn-clear {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 8px 15px;
    height: auto;
    &.active {
      background: $gray-2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/editor/ToolBar.vue